import WebFont from 'webfontloader'

const options = {"custom":{"families":["Oswald:n2,n3,n4,n5,n6,n7","Roboto:n1,n3,n4,n5,n7,n9,i1,i3,i4,i5,i7,i9"],"urls":["https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Oswald:200,300,400,500,600,700&amp;subset=cyrillic,latin-ext&display=swap","https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i&display=swap&subset=cyrillic,cyrillic-ext,latin-ext"]}}

WebFont.load(options)
